import { Space } from '@sravni/react-design-system';
import { Heading, Text } from '@sravni/react-design-system/lib/Typography';
import cn from 'classnames';

import { useAppSelector } from 'shared/lib/redux';
import { AdaptiveCard } from 'shared/ui/AdaptiveCard';

import { seoBlocksSelector } from 'entities/metadata';

import styles from './SeoBlocks.module.scss';

export const SeoBlocks: FC = ({ className }) => {
  const seoBlocks = useAppSelector(seoBlocksSelector)?.text;
  if (!seoBlocks) return null;

  return (
    <Space
      direction="vertical"
      size={16}
    >
      {seoBlocks.map((seoBlock) => (
        <AdaptiveCard
          color="light"
          className={cn(styles.wrapper, className)}
          key={seoBlock.text}
        >
          <Space
            direction="vertical"
            size={16}
          >
            {!!seoBlock?.title && (
              <Heading
                level={2}
                className={styles.seoHeading}
                dangerouslySetInnerHTML={{ __html: seoBlock?.title }}
              />
            )}
            <Text
              className={styles.seoWrapper}
              dangerouslySetInnerHTML={{ __html: seoBlock?.text }}
            />
          </Space>
        </AdaptiveCard>
      ))}
    </Space>
  );
};
